<!--footer--->
<footer class="footer">

    <div class="foobot b5containeradjust">
        <div class="container">
            <div class="d-flex flex-column justify-content-center px-3 align-items-center">
                <div class="d-flex align-items-center ps-0 gap-4">
                    <a name="btn_Callus_ForgotPassword" href="tel:0875376113" class="callus text-black fw-medium text-decoration-none">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M2.38477 0.805998C3.12689 0.0638833 4.35149 0.140125 4.99583 0.968556L6.78954 3.27475C7.1187 3.69796 7.23502 4.24901 7.10498 4.76915L6.55772 6.95821C6.49994 7.18932 6.56766 7.4338 6.7361 7.60224L9.19268 10.0588C9.36113 10.2273 9.6056 10.295 9.83671 10.2372L12.0258 9.68994C12.5459 9.55991 13.097 9.67622 13.5202 10.0054L15.8264 11.7991C16.6548 12.4434 16.731 13.668 15.9889 14.4102L14.955 15.4441C14.2153 16.1838 13.1089 16.5086 12.0778 16.1461C9.51754 15.246 7.11438 13.7723 5.06849 11.7264C3.0226 9.68054 1.54895 7.27738 0.648838 4.71717C0.286318 3.68605 0.61113 2.57964 1.35085 1.83992L2.38477 0.805998Z"
                                fill="#222223" />
                            </svg>
                        </span>
                        087 537 6113</a>
                    
                        
                    <div class="fw-medium">
                        <a href="mailto:info@justmoney.co.za" class="text-decoration-none text-black">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <path
                                        d="M0.549585 3.85036C0.75173 2.95976 1.54822 2.29492 2.5 2.29492H14.5C15.4518 2.29492 16.2483 2.95976 16.4504 3.85036L8.5 8.70895L0.549585 3.85036ZM0.5 4.99201V12.0955L6.30319 8.5384L0.5 4.99201ZM7.2614 9.12397L0.691871 13.1508C1.0126 13.8272 1.70168 14.2949 2.5 14.2949H14.5C15.2983 14.2949 15.9874 13.8272 16.3081 13.1508L9.7386 9.12397L8.5 9.88089L7.2614 9.12397ZM10.6968 8.5384L16.5 12.0955V4.99201L10.6968 8.5384Z"
                                        fill="#222223" />
                                    </svg>
                            </span>
                            info&#64;justmoney.co.za
                        </a>
                    </div>
                </div>

                <div class="d-flex flex-column justify-content-around align-items-center mt-3 foot-logo-container">
                    <p class="foot-logo-text">Credit Bureau data provided by</p>
                    <img *ngIf="!showMyDataLogo" src="../../assets/images/vccb-logo.png" width="130px" alt="vccb logo">
                    <img *ngIf="showMyDataLogo" src="../../assets/images/mydata-logo.png"  width="130px" alt="mydata logo">
                </div>

            </div>
        </div>
    </div>
</footer>
<!--footer--->